const utils = require('frontend-controller/lib/utils')
const popoverController = require('frontend-controller/lib/controllers/popover')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'scheduler',
        'scheduler',
    ],

    config: {
        showNav: {
            showOptions: true,
            periodSelection: false,
            periodSelectionSlim: true,
        },
        datePickerFieldConfigByViewPeriod: {
            day: {
                airDatePicker: {
                    isMobile: true,
                },
            },
            week: {
                airDatePicker: {
                    isMobile: true,
                },
            },
            month: {
                airDatePicker: {
                    isMobile: true,
                },
            },
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_absence': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_customers': false,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': true,
            'resourceChanged.bo_customerContacts': false,
            'resourceChanged.bo_projectTermJobStatus': true,
        },
    },

    model: {
        datePickerData: {
            config: {
                inputSize: 12
            }
        }
    },

    methods: {
        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return utils.collectionSize((resourceFilters || {}).filters) > 0
            }

            return true
        },

        sanitizeResources(){
            this.model.taskData = []

            let entitySymbol, taskContent, statusSymbol
            utils.forEach(this.resourceData.scheduleData || this.resourceData.data || [], (element, key) => {
                entitySymbol = ''
                taskContent = ''
                statusSymbol = ''

                const attributes = element.attributes || element || {}
                const type = attributes.type
                const classes = [type]
                if(attributes.status){
                    classes.push(`status_${attributes.status}`)
                }
                if(attributes.statusOutDated){
                    classes.push(`statusOutDated`)
                }
                if(type === 'project'){
                    taskContent = `<div class="term">${utils.moment(attributes.startTS).format('HH:mm') || ''} | ${attributes.title || ''}</div>`
                } else if(type === 'absence'){
                    taskContent = `<div>${attributes.title || '&nbsp;'}</div>`

                    const {
                        absenceType,
                        absenceStatus,
                    } = attributes
                    if(absenceType){
                        entitySymbol = `<i class="entitySymbol fi fi-${absenceType}"></i>`

                        if(absenceType === 'notAvailable' || absenceStatus === 'confirmed'){
                            classes.push('absenceStatus_confirmed')
                        } else if(absenceStatus === 'rejected'){
                            classes.push('absenceStatus_rejected')
                        }
                    }
                } else if(type === 'advertisement'){
                    const contentParts = [], timeParts = []
                    if(attributes.jobCode)  contentParts.push(attributes.jobCode);
                    if(attributes.startTS)  timeParts.push(utils.moment(attributes.startTS).format('HH:mm'));
                    if(attributes.endTS)    timeParts.push(utils.moment(attributes.endTS).format('HH:mm'));
                    if(timeParts.length)    contentParts.push(timeParts.join(' - '))
                    if(attributes.location) contentParts.push(attributes.location)

                    taskContent = `<div class="ad">${contentParts.join(' | ') || '&nbsp;'}</div>`
                }

                this.model.taskData.push({
                    title: `${entitySymbol}${taskContent}${statusSymbol}`,
                    alt: attributes.title,
                    date: attributes.startTS,
                    class: classes.join(' '),
                    dataType: type,
                    dataID: key,
                    showTime: false,
                    attributes,
                })
            })
        },

        onTaskClicked(taskType, taskID){
            const {dataType} = (this.model.taskData[taskID] || {})
            if(dataType === 'project'){

                const {projectID, projectTermID, projectTermJobID} = (this.model.taskData[taskID].attributes || {})
                if(projectID && projectTermID){

                    getComponent('projectViewer').show(projectID, projectTermID, projectTermJobID, {
                        schedulerOptions: ((this.model.resourceFilters || {}).filters || {}).items || {}
                    })
                        .then(() => getComponent('mainNav').navToList('projects'))
                }
            } else if(dataType === 'absence'){
                const {absenceID} = (this.model.taskData[taskID].attributes || {})
                if(absenceID){
                    getComponent('absenceController').showEdit('absence', absenceID)
                }
            } else if(dataType === 'advertisement'){
                const entityData = this.model.taskData[taskID] || {}
                const {statusDataHash} = (entityData.attributes || {})
                if(statusDataHash){
                    getComponent('advertisementsController').showEdit('advertisements', statusDataHash, entityData)
                }
            }
        },

        onShowOptions($button, triggerSelector){
            // NOTE: this function may be overwritten
            return this.performAndStoreAction(
                'showSchedulerOptions_inEffect',
                this.prepareAction(popoverController.getPopoverAction($button, triggerSelector), undefined, undefined, {
                    source: {
                        container: {
                            componentData: {
                                config: {
                                    orientation: 'S',
                                    autoOpen: true,
                                    distance: {
                                        y: '10px',
                                    },
                                }
                            }
                        },
                        content: {
                            componentData: {
                                component: [
                                    'templates',
                                    'crew',
                                    'scheduler',
                                    'schedulerOptions',
                                ],
                            },
                        },
                    }
                })
            )
        },
    },

    hooks: {
        schedulerOptionsChanged($element, options){
            const {schedulerOptions} = (options || {})

            this.updateFilters({
                ...((this.model.resourceFilters || {}).filters || {}),
                items: schedulerOptions
            })

            this.callHandler('schedulerOptionsChanged', [schedulerOptions])
        },
    },
}